import { useRef, useMemo } from "react"
import { useFrame } from "@react-three/fiber"
import * as THREE from "three"
import { useGLTF, useTexture, PerspectiveCamera } from "@react-three/drei"

export default function Scene() {
  const oceanRef = useRef<THREE.Mesh>(null)

  const skyTexture = useTexture("/webVR/miami360.jpg")
  const model = useGLTF("/webVR/untitled.glb")

  const waveData = useMemo(() => {
    return Array.from({ length: 5000 }, () => ({
      base: Math.random(),
      speed: 0.01 + Math.random() * 0.02,
    }))
  }, [])

  useFrame(() => {
    if (!oceanRef.current) return

    const pos = oceanRef.current.geometry.attributes.position

    for (let i = 0; i < pos.count; i++) {
      const v = waveData[i % waveData.length]
      const z = pos.getZ(i)
      pos.setZ(i, z + Math.sin(Date.now() * v.speed + i) * 0.002)
    }

    pos.needsUpdate = true
  })

  return (
    <>
      <PerspectiveCamera
        makeDefault
        position={[-14.9, 10.9, -23.4]}
        fov={65}
      />

      <ambientLight intensity={1} />
      <directionalLight position={[0, 15, 5]} intensity={1.8} />

      <mesh ref={oceanRef} rotation={[-Math.PI / 2, 0, 0]} position={[0, 8, -90]}>
        <planeGeometry args={[500, 400, 100, 100]} />
        <meshStandardMaterial color="#00d4d4" transparent opacity={0.6} />
      </mesh>

      <mesh>
        <sphereGeometry args={[500, 60, 40]} />
        <meshBasicMaterial map={skyTexture} side={THREE.BackSide} />
      </mesh>

      <primitive object={model.scene} position={[0, 5.5, -10]} />
    </>
  )
}